import { Box, Typography, Divider, List, ListItem, ListItemText } from "@mui/material";
import Container from "../base/Container";

const ClientHistory = () => {
  return (
    <Container>
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        height: "100vh",
        p: 2,
        gap: 2,
      }}
    >
      {/* Transcript Section */}
      <Box
        sx={{
          width: "25%",
          border: "1px solid #ccc",
          borderRadius: 1,
          p: 2,
        }}
      >
        <Typography variant="h6">Transcript</Typography>
        <Divider sx={{ my: 2 }} />
        <List>
          <ListItem>
            <ListItemText primary="Meeting 1" secondary="Details of meeting 1..." />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText primary="Meeting 2" secondary="Details of meeting 2..." />
          </ListItem>
        </List>
      </Box>

      {/* Graph Section */}
      <Box
        sx={{
          width: "50%",
          border: "1px solid #ccc",
          borderRadius: 1,
          p: 2,
        }}
      >
        <Typography variant="h6">Graph</Typography>
        <Divider sx={{ my: 2 }} />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            gap: 2,
          }}
        >
          <Box
            sx={{
              flex: 1,
              border: "1px dashed #aaa",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Graph V1 (Placeholder)
          </Box>
          <Divider />
          <Box
            sx={{
              flex: 1,
              border: "1px dashed #aaa",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Graph V2 (Placeholder)
          </Box>
        </Box>
      </Box>

      {/* Summary Section */}
      <Box
        sx={{
          width: "25%",
          border: "1px solid #ccc",
          borderRadius: 1,
          p: 2,
        }}
      >
        <Typography variant="h6">Summary</Typography>
        <Divider sx={{ my: 2 }} />
        <List>
          <ListItem>
            <ListItemText primary="File Note 1" />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText primary="File Note 2" />
          </ListItem>
        </List>
      </Box>
    </Box>
    </Container>
  );
};

export default ClientHistory;
